{
  "title": "How to Create an Account and Verify Your Email",
  "description": "Register with an email and password, then verify your email via a confirmation link to activate your account.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, you have a working account with a verified email, and can start joining or creating a team.",
  "roleNote": "Anyone who doesn't have an account yet",
  "prerequisites": [
    "An email address you can receive mail at",
    "A password of at least 10 characters"
  ],
  "pathLabel": "Register",
  "steps": [
    {
      "title": "1. Fill in the registration form",
      "description": "Enter your email, a password (at least 10 characters), and a display name, pass the bot check (Turnstile), and submit."
    },
    {
      "title": "2. Read the on-screen message",
      "description": "After submitting, you always see the same \"check your inbox\" message regardless of whether that email was already registered — this is intentional, to prevent the form from being used to probe which emails already have accounts."
    },
    {
      "title": "3. Open the verification email and click the link",
      "description": "Check your inbox (and spam folder) and click the link in the email; the link is valid for 24 hours."
    },
    {
      "title": "4. Verification completes and you're signed in automatically",
      "description": "Clicking the link creates your account, marks your email as verified, and issues you a session automatically — you're taken straight to the platform's home page, with no separate manual sign-in step needed."
    }
  ],
  "afterward": [
    "Your account exists, your email is verified, and you're already signed in",
    "You can start browsing competitions and joining or creating a team"
  ],
  "nextSteps": "Next, see \"How to Create or Join a Team\" to start participating in a competition.",
  "faq": [
    {
      "q": "I never received the verification email — what should I do?",
      "a": "Check your spam folder first. If it's still not there, resubmit the registration form with the same email — the system will send a fresh verification email (the new link replaces the old one, which becomes invalid)."
    },
    {
      "q": "What happens if the verification link has expired or was already used?",
      "a": "You'll see a message saying the link is invalid or expired; register again with the same email to get a fresh verification link."
    },
    {
      "q": "I submitted the form with an email, and the screen didn't clearly say \"this email is already registered\" — is that expected?",
      "a": "Yes. The screen always shows the same success message regardless of whether that email is already registered — this is deliberate, to prevent account-enumeration attacks. If that email already has an account, just use the sign-in page directly; there's no need to register again."
    }
  ]
}
